import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FieldForm } from '@app/src/common/FieldForm';
import { Field, change } from 'redux-form';
import * as validate from '@app/src/utils/validations';
import { renderInput } from '@app/src/common/Input/renderInput';

interface Props {
  placeholder: string;
}

export const InputTitle: React.FC<Props> = ({ placeholder }) => {
  const dispatch = useDispatch();
  const currentTitle = useSelector(state => state.form.stepOne.values.title);
  const printTitle = useSelector(state => state.print.general.title);

  useEffect(() => {
    if (printTitle) {
      dispatch(change('stepOne', 'title', printTitle));
    } else {
      dispatch(change('stepOne', 'title', ''));
    }
    return () => {
      if (!printTitle) {
        dispatch(change('stepOne', 'title', ''));
      }
    }
  }, []);

  return (
    <FieldForm label="Título de la publicación">
      <Field
        name="title"
        placeholder={placeholder}
        maxLength={14}
        component={renderInput}
        validate={[validate.required, validate.minLength3]}
        defaultValue={currentTitle}
      />
    </FieldForm>
  )
};
